import React, { useState, useEffect, useRef } from 'react';
import { db } from '../../firebase.js'; // Ya estaba correcto
import { collection, query, getDocs, orderBy } from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { Send, X } from 'lucide-react';
import Swal from 'sweetalert2';

const addUserMessageToTicket = httpsCallable(getFunctions(), 'api');

const TicketConversationModal = ({ ticket, onClose }) => {
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState('');
    const [isSending, setIsSending] = useState(false);
    const messagesEndRef = useRef(null);
    const inputRef = useRef(null); // --- NUEVO: Ref para el campo de texto ---

    useEffect(() => {
        if (!ticket) return;
        const messagesRef = collection(db, 'support_tickets', ticket.id, 'messages');
        const q = query(messagesRef, orderBy('createdAt', 'asc'));

        let cancelled = false;
        let intervalId = null;

        const fetchMessages = async () => {
            try {
                const snap = await getDocs(q);
                if (cancelled) return;
                setMessages(snap.docs.map(d => ({ id: d.id, ...d.data() })));
            } catch (err) {
                console.error('Error fetching ticket messages:', err);
            }
        };

        fetchMessages();
        intervalId = setInterval(fetchMessages, 2000); // chat needs more responsiveness; short poll

        return () => {
            cancelled = true;
            if (intervalId) clearInterval(intervalId);
        };
    }, [ticket]);

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages]);

    const handleSendMessage = async (e) => {
        e.preventDefault();
        if (!newMessage.trim()) return;

        setIsSending(true);
        try {
            await addUserMessageToTicket({ 
                __fn: 'addUserMessageToTicket', 
                ticketId: ticket.id, 
                message: newMessage.trim() 
            });
            setNewMessage('');
            // --- MEJORA DE UX: Enfocar el input después de enviar ---
            inputRef.current?.focus();
        } catch (error) {
            Swal.fire('Error', `No se pudo enviar el mensaje: ${error.message}`, 'error');
        } finally {
            setIsSending(false);
        }
    };

    if (!ticket) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content support-modal">
                <div className="modal-header">
                    <h3>Ticket #{ticket.id.substring(0, 6)}: {ticket.subject}</h3>
                    <button onClick={onClose} className="close-button"><X size={24} /></button>
                </div>
                <div className="modal-body">
                    <div className="support-chat-messages">
                        {messages.length === 0 && <p className="empty-chat-message">Cargando mensajes...</p>}
                        {messages.map(msg => (
                            <div key={msg.id} className={`message-bubble ${msg.sender}`}>
                                <p>{msg.text}</p>
                                <span className="message-timestamp">
                                    {msg.createdAt?.toDate().toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })}
                                </span>
                            </div>
                        ))}
                        <div ref={messagesEndRef} />
                    </div>
                </div>
                <div className="modal-footer">
                    <form onSubmit={handleSendMessage} className="support-chat-form">
                        <input 
                            ref={inputRef} // --- NUEVO: Asignar la ref ---
                            type="text" 
                            value={newMessage} 
                            onChange={(e) => setNewMessage(e.target.value)} 
                            placeholder="Escribe tu respuesta..." 
                            required 
                            disabled={isSending}
                        />
                        <button type="submit" disabled={!newMessage.trim() || isSending}>
                            {isSending ? '...' : <Send size={20} />}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default TicketConversationModal;